import { Container, Row, Col, Card } from 'react-bootstrap'
import { motion } from 'motion/react'
import digitalData from '../../data/digitalData.json'

const Services = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  return (
    <section className='section-lg' id='services'>
      <Container>
        <Row className="text-center mb-5">
          <Col lg={8} className="mx-auto text-center">
            <div className="service-heading mb-3">
              <motion.h6 className="underline-after text-center position-relative z-0"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <span className="position-relative z-1 bg-white text-primary px-3">Our Services</span>
              </motion.h6>
              <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                Digital Marketing Solutions
              </motion.h2>
            </div>
            <motion.p 
              className="lead text-secondary"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              We offer comprehensive digital marketing services to help your business grow online and reach your target audience effectively.
            </motion.p>
          </Col>
        </Row>
        <motion.div variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4">
            {digitalData.services.map((service) => (
              <Col lg={4} md={6} key={service.id}>
                <motion.div
                  variants={cardVariants}
                  whileHover={{ y: -10, transition: { duration: 0.3 } }}
                >
                  <Card className={`service-card service-card-soft-${service.variant} rounded-0 overflow-hidden h-100`}>
                    <Card.Body className={`text-${service.variant} text-center z-2`}>
                      <motion.div className={`icons my-3 d-inline-flex card-icon align-items-center justify-content-center bg-${service.variant}-subtle text-${service.variant} rounded-3`}
                        whileHover={{ rotate: 360, scale: 1.1 }}
                        transition={{ duration: 0.5 }}
                      >
                        <i className={`${service.icon} fs-3`}></i>
                      </motion.div>
                      <h4 className="fw-semibold mb-3">{service.title}</h4>
                      <p className="text-secondary mb-0">{service.description}</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Services;
